import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {Observable} from 'rxjs';

@HookClass('database')
export class DatabaseHook extends BaseHook {

    @Hook('eba6aea9-2949-461c-bff9-8b6f7feec9c2')
    public reindex(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return null;
    }

}
